import * as React from "react";
import { IOWidget, mk_widget, option, Options, Unit, Widget } from "../widget";

export interface ListItem<o> {
  widget:Widget<o>,
  options?:Options
}

export interface ListItem_io<i,o> {
  widget:IOWidget<i,o>,
  options?:Options
}

interface UnorderedListProps<i,o> {
  options?:Options,
  input:i,
  list_items:ListItem_io<i,o>[],
  on_done:(output:o) => void
}
interface UnorderedListState<_i,_o> { }

/** @deprecated Use [[wrapHTML]] instead. */
class UnorderedList<i,o> extends React.Component<UnorderedListProps<i,o>, UnorderedListState<i,o>> {
  constructor(props:UnorderedListProps<i,o>, context:any) {
    super(props, context)

    this.state = {}
  }

  render() {
    return <ul  className={this.props.options ? this.props.options.className : undefined}
                key={this.props.options ? this.props.options.key : undefined}
                {...option("extraProperties", this.props.options)} >
      {
        this.props.list_items.map(w => {
          let actual_w = w.widget(this.props.input)
          return <li  key={option("key", w.options)}
                      className={option("className", w.options)}
                      {...option("extraProperties", w.options)} >
            {
              actual_w.run(this.props.on_done)
            }
          </li>
        })
      }
    </ul>
  }
}

/** @deprecated Use [[wrapHTML]] instead. */
export const unordered_list_io = function<i,o>(options?:Options) : (list_items:ListItem_io<i,o>[]) => IOWidget<i,o> {
  return list_items => (input:i) => mk_widget({
    run:(on_done:(output:o) => void) =>
      React.createElement<UnorderedListProps<i,o>>(UnorderedList, { list_items, on_done, input, options })
  })
}

/** @deprecated Use [[wrapHTML]] instead. */
export const unorderedList = function<o>(options?:Options) : (list_items:ListItem<o>[]) => Widget<o> {
  return list_items => unordered_list_io<Unit,o>(options)(list_items.map(li => ({...li, widget:(_:Unit) => li.widget }) ))({})
}
